import { createContext, useContext } from "react";
import { LayoutPage } from "./types";

export const pagesContext = createContext<LayoutPage[]>([]);
pagesContext.displayName = "Pages";

export const PagesProvider = pagesContext.Provider;

export const usePages = () => useContext(pagesContext);
